export default __webpack_public_path__ + "static/media/affogato.26377b27.webp";